
import { Options, Vue } from "vue-class-component";
import Notification from "@/app/ui/components/notification-update/index.vue";
import { clearDataSessionStorage } from "./app/infrastructures/misc/SessionStorage";
import { clearDataLocalStorage } from "./app/infrastructures/misc/LocalStorage";

@Options({
  name: "App",
  components: {
    Notification
  }
})
export default class extends Vue {
  refreshing = false;
  registration: any = null;
  updateExists = false;
  created() {
    document.addEventListener("swUpdated", this.updateAvailable, {
      once: true
    });
    // Prevent multiple refreshes
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (this.refreshing) return;
      this.refreshing = true;
      // Here the actual reload of the page occurs
      window.location.reload();
    });

    // On every tab, listen for logout
    window.addEventListener("storage", event => {
      if (event.key === "logout-event") {
        clearDataSessionStorage(); // or navigate to login
        clearDataLocalStorage();
        this.$router.replace({ name: "login" });
      }
    });
    this.keepScrollTop();
  }
  async updateAvailable(event: any) {
    this.registration = event.detail;
    this.updateExists = true;
    // wait for 3s then force update
    await new Promise(resolve => setTimeout(resolve, 3000));
    // send message to SW to skip the waiting and activate the new SW
    if (this.registration?.waiting) {
      this.registration.waiting.postMessage({ type: "SKIP_WAITING" });
    } else {
      console.warn("No service worker in 'waiting' state.");
    }
  }

  // Called when the user accepts the update
  refreshApp() {
    this.updateExists = false;
    // Make sure we only send a 'skip waiting' message if the SW is waiting
    if (!this.registration || !this.registration.waiting) return;
    // send message to SW to skip the waiting and activate the new SW
    this.registration?.waiting.postMessage({ type: "SKIP_WAITING" });
  }

  get gtmId() {
    return process.env.VUE_APP_GTM_ID;
  }

  keepScrollTop() {
    const app = document.getElementById("app");
    if (!app) return;

    const keepAtTop = () => {
      if (app.scrollTop !== 0) app.scrollTop = 0;
    };

    app.addEventListener("scroll", keepAtTop, { passive: true });
  }
}
